
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partnership/business-partners",
      function () {
        return require("private-next-pages/partnership/business-partners/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partnership/business-partners"])
      });
    }
  